import { view } from "@risingstack/react-easy-state";
import { useEffect, useState } from "react";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import FSADataTable from "./components/FSADataTable";
import BedrockMatchTable from "./components/BedrockMatchTable";
import FSAMatchActions from "./components/FSAMatchActions";
import PostcodeSearchPanel from "./components/PostcodeSearchPanel";
import ABPDataTable from "./components/ABPDataTable";
import WorkflowIndicator from "./components/WorkflowIndicator";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";
import "./FSAMatch.scss";

export default view(function FSAMatch() {
    const [workflowItems, setWorkflowItems] = useState([]);
    const [workflowIndex, setWorkflowIndex] = useState(0);
    const [fsaMatch, setFsaMatch] = useState(null);
    const [bedrockMatch, setBedrockMatch] = useState(null);
    const [abpResults, setAbpResults] = useState([]);
    const [translations, setTranslations] = useState({})

    const fetchWorkflowItems = () => {
        return request(true).get(endpoints.FSA_MATCH_WORKFLOW).then(r => {
            setWorkflowItems(r.data);
            setWorkflowIndex(0);
        }).catch(e => {
            console.error(e);
        });
    }

    useEffect(() => {
        request(true).get('/translate?key=fsa_match')
            .then(e => {
                setTranslations(e.data)
            })
        fetchWorkflowItems();
    }, []);

    useEffect(() => {
        const fhrsid = workflowItems[workflowIndex];
        if (!fhrsid) {
            setFsaMatch(null);
            setBedrockMatch(null);
            return;
        }

        request(true).get(endpoints.FSA_MATCH_GET, { params: { FHRSID: fhrsid } }).then(r => {
            setFsaMatch(r.data.fsa_match);
            setBedrockMatch(r.data.bedrock_match);
        }).catch(e => {
            console.error(e);
        });
    }, [workflowIndex, workflowItems]);

    const goToPrevious = () => {
        setWorkflowIndex(prev => Math.max(prev - 1, 0));
    }

    const goToNext = () => {
        setWorkflowIndex(prev => Math.min(prev + 1, workflowItems.length - 1));
    }

    return (
        <GenericPageContainer
            title="FSA Match"
            titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
            containerWidth="95vw"
        >
            <div className="grid grid-gap-15 fsa-match">
                <WorkflowIndicator
                    current={workflowIndex}
                    total={workflowItems.length}
                    onPrevious={goToPrevious}
                    onNext={goToNext}
                />
                <div className="fsa-match-top-section">
                    <FSADataTable data={fsaMatch} translations={translations} />
                    <BedrockMatchTable data={bedrockMatch} translations={translations} />
                    <FSAMatchActions FHRSID={workflowItems[workflowIndex]} onUpdated={fetchWorkflowItems} translations={translations} />
                </div>
                <PostcodeSearchPanel onResults={setAbpResults} searchPostcode={fsaMatch?.POSTCODE} translations={translations} />
                <div className="fsa-match-table-container">
                    <ABPDataTable results={abpResults} translations={translations} />
                </div>
            </div>
        </GenericPageContainer>
    );
})